import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutMultiReprintMiscBill extends Layout {
    sourceMultiReprintMiscBill: DataSource;
}
